import React from "react";
import ReactDOM from "react-dom/client";
import axios from "axios";
import "@/index.css";
import App from "@/App";

// All API calls go to our same-origin FastAPI; httpOnly Studio session cookie
// must ride every request. Previously each call had to opt-in via
// `withCredentials: true` — a single missed call silently 401'd and callers
// swallowed the error (Studio Case Studies listed 0 drafts even though 2
// existed). Setting the default once removes that whole class of bugs.
axios.defaults.withCredentials = true;

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
